import { ReactElement } from 'react';

import { DocplannerServiceMappingRemoveCommand } from '@dreryk/egabinet-docplanner-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { medicalServicesMappingsTranslationKeys } from '../../../translations';

const useMedicalServiceRemoveCommand = (mappingId: number, onSuccess: VoidFunction): UseCqrsCommandResult<void> => {
   return useCqrsCommand(
      () => {
         const command = new DocplannerServiceMappingRemoveCommand();
         command.mappingId = mappingId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(medicalServicesMappingsTranslationKeys.mappingRemoved);
            onSuccess();
         },
      }
   );
};

type DocplannerServiceMappingRemoveButtonProps = {
   readonly onSuccess: VoidFunction;
   readonly mappingId: number;
};

export const DocplannerServiceMappingRemoveButton = (
   props: DocplannerServiceMappingRemoveButtonProps
): ReactElement => {
   const { executeAsync: removeServiceMapping } = useMedicalServiceRemoveCommand(props.mappingId, props.onSuccess);
   return <ModalConfirmButton label={medicalServicesMappingsTranslationKeys.remove} onClick={removeServiceMapping} />;
};
